import { z } from 'zod';

export const StaffChatCustomerListItemSchema = z.object({
  partyId: z.uuid(),
  displayName: z.string().min(1),
  consumerId: z.uuid(),
});
export type StaffChatCustomerListItem = z.infer<typeof StaffChatCustomerListItemSchema>;

export const StaffChatCustomersResponseSchema = z.object({
  items: z.array(StaffChatCustomerListItemSchema),
});
export type StaffChatCustomersResponse = z.infer<typeof StaffChatCustomersResponseSchema>;

export const OpenStaffConversationForPartyBodySchema = z.object({
  partyId: z.uuid(),
});
export type OpenStaffConversationForPartyBody = z.infer<
  typeof OpenStaffConversationForPartyBodySchema
>;

export const OpenStaffConversationForPartyResponseSchema = z.object({
  conversationId: z.uuid(),
  consumerId: z.uuid(),
  tenantId: z.uuid(),
  placeId: z.uuid(),
});
export type OpenStaffConversationForPartyResponse = z.infer<
  typeof OpenStaffConversationForPartyResponseSchema
>;
